import { combineReducers } from 'redux';
import { ClockinStore } from './ClockinStore';
import { ClockinDateFilterStore } from './ClockinDateFilterStore';
import { ClockinUserUidStore } from './ClockinUserUidStore';
import { ClockinUsersStore } from "./ClockinUsersStore";
import { ClockinFiltersStore } from "./ClockinFiltersStore";
import { ClockinVacationStore } from './ClockinVacationStore';
import { ClockinWorkShiftStore } from './ClockinWorkShiftStore';
import { ClockinWorkingCalendarStore } from './ClockinWorkingCalendarStore';
import { AuthorizationStore } from './AuthorizationStore';

export const clockinReducer = combineReducers({
    clockins:       ClockinStore.reducerCollection,
    dateFilter:     ClockinDateFilterStore.reducer,
    userUid:        ClockinUserUidStore.reducer,
    clockinUsers:   ClockinUsersStore.reducerCollection,
    filter:         ClockinFiltersStore.reducer,
    vacation:       ClockinVacationStore.reducerCollection,
    working_calendar_items:       ClockinWorkingCalendarStore.reducerCollection,
    work_shifts:    ClockinWorkShiftStore.reducerCollection,
    authorizations: AuthorizationStore.reducerCollection,
});

let getRootState = state => state;

export const ClockinSelectors = {
    getDateFilter:      state => ClockinDateFilterStore.selectorGetBeginEnd(getRootState(state).dateFilter),
    getClockins:        state => ClockinStore.selectorGetItems(getRootState(state).clockins),
    getSelectedUserUid: state => getRootState(state).userUid,
    getClockinUsers:    state => ClockinUsersStore.selectorGetItems(getRootState(state).clockinUsers),
    getClockinsFilter:  state => getRootState(state).filter,
    getClockinsVacation: state => ClockinVacationStore.selectorGetItems(getRootState(state).vacation),
    getClockinsWorkingCalendarEntries: state => ClockinWorkingCalendarStore.selectorGetItems(getRootState(state).working_calendar_items),
    getClockinsWorkShifts: state => ClockinWorkShiftStore.selectorGetItems(getRootState(state).work_shifts),
    getAuthorizations: state => AuthorizationStore.selectorGetItems(getRootState(state).authorizations),

    setRootStateFn: (rootStateFn = state => state) => getRootState = rootStateFn,
};
